import ContractRedeem from './ContractRedeem.vue';

export default ContractRedeem;
